import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import "./style.scss";
import orderStore from "../../stores/order";
import menuStore from "../../stores/menu";
import {hideLoader, showLoader} from "../../helpers/ComponentHelper";
import {CombinationOrderLine_Step} from "../../@types/stores/order";
import { v4 as guid } from 'uuid';

const FooterForInfoHalfAndHalf = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const goBack = () => {
        menuStore.changeMenuItem();
        navigate("/menu");
    }

    const goToStart = async () => {
        await orderStore.cancelOrder();
        navigate("/");
    }

    const addToOrder = async () =>{
        showLoader();
        if (menuStore.editHalfAndHalfId) {
           await  orderStore.removeOrderLine(menuStore.editHalfAndHalfId);
        }

        const steps: CombinationOrderLine_Step[] = [];
        let price = 0;
        let extraPrices = 0;
        for (let i = 0; i < menuStore.selectedHalfAndHalfItems.length; i++) {
            const item = menuStore.selectedHalfAndHalfItems[i];
            if (item) {
                const linePrice = item.price;// + orderStore.getExtraPriceFromOrderLine(item); - correct logic is compare item unit prices, after that add extra prices to total
                price = price < linePrice ? linePrice : price;

                extraPrices += orderStore.getExtraPriceFromOrderLine(item);

                steps.push({
                    id: i,
                    name: t(`halfNHalf.stepTitle.${i}`),
                    articles: [item]
                });
            }
        }

        await orderStore.addHalfAndHalfToOrder({
            id: guid(),
            menuId: menuStore.navigation.category,
            subMenuId: menuStore.navigation.subCategory,
            name: "halfAndHalf",
            count: 1,
            price: price + extraPrices,
            total: price + extraPrices,
            steps
        });
        hideLoader();

        navigate(menuStore.editHalfAndHalfId ? "/order" : "/menu");
        menuStore.editHalfAndHalfId = "";
    }

    return <>
        <div className="FooterSpace" />
        <div className="FooterForInfoHalfAndHalf">
            <div className="buttons">
                <div className="button back" onClick={goBack}>{t("back")}</div>
                <div className="button dark" onClick={addToOrder}>{t("addToOrder")}</div>
            </div>
            <div className="startOverContainer">
                <div className="button startOver noBorder" onClick={goToStart}>{t("startOver")}</div>
            </div>
        </div>
    </>
}

export default FooterForInfoHalfAndHalf;
